<template>
    <el-dialog title="回放记录" :visible.sync="showTag" :append-to-body="true" width="80%">
        <div id="player-con" style="height: 500px"></div>
    </el-dialog>
</template>

<script>
  export default {
    name: "wlmz-record-player-dialog",
    data() {
      return {
        data: {},
        showTag: false
      }
    },
    methods: {
      init() {
        const player = new Aliplayer({
            "id": "player-con",
            "source": "//player.alicdn.com/video/aliyunmedia.mp4",
            "width": "100%",
            "height": "500px",
            "autoplay": true,
            "isLive": false,
            "rePlay": false,
            "playsinline": true,
            "preload": true,
            "controlBarVisibility": "hover",
            "useH5Prism": true
          }, function (player) {

          }
        );
      },
      show(data) {
        this.data = data;
        this.showTag = true;
        this.$nextTick(() => {
          this.init();
        });
      },
      hide() {
        this.showTag = false;
      }
    },
  }
</script>

<style scoped>

</style>
